export const RDI = 'rdi';
export const AUTHORIZATION = 'X-Authorization';
export const PACE_AUTHORIZATION = 'Pace-Authorization'; 
export const TRANSLATIONS_VERSION = 'translation-version';
export const USER_PLATFORM_HEADER = 'user-platform';
